module.exports = __webpack_public_path__ + "img/iraq.82fceb0d.svg";